// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2_uad","rootSuccess":"CompleteLink_rootSuccess__qz1uM","rootFailure":"CompleteLink_rootFailure__33ygy","isDisabled":"CompleteLink_isDisabled__2HeCe"};